import { googlePlayStoreLink } from './branchUrls';
import { images } from './ImageUrls';

export const headerFooterData = [
  //key :=> type 0 for both, 1 for header only, 2 for footer only
  {
    type: 2, // 0 for both, 1 for header only, 2 for footer only
    title: 'Trending Products',
    subCategories: [
      {
        name: 'Baby Diaper pants',
        deepLink: '/product/mylo-baby-diaper-pants-s-pack-of-42-2378',
        deepLinkType: 'next',
      },
      {
        name: 'Stretch Marks Cream',
        deepLink:
          '/product/stretch-marks-combo---removes-scars-made-with-natural-ingredients-tightens-skin---stretch-mark-oil---979',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Wrapper',
        deepLink:
          '/product/ultra-soft-cute-baby-swaddling-wrapper-sleeping-bag-cum-all-season-ac-blanket-0-6-months-light-pink-mint-green-1289',
        deepLinkType: 'next',
      },
      {
        name: 'Ovaluna',
        deepLink:
          '/product/ovaluna-conception-fertility-tablets-for-women-promote-natural-conception-improve-egg-health-3663',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Carrier',
        deepLink:
          '/product/baby-carrier-bag-for-0-to-3-years-with-4-comfortable-carrying-positions-lightweight-travel-friendly--3433',
        deepLinkType: 'next',
      },
      {
        name: 'Bath Regime kit',
        deepLink:
          '/product/baby-bath-regime-kit---baby-massage-oil-baby-head-to-toe-wash-baby-talc-free-powder-3888',
        deepLinkType: 'next',
      },
      {
        name: 'Mosquito Repellant',
        deepLink: '/product/mosquito-repellent-patches-pack-of-24-907',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Wipes',
        deepLink:
          '/product/gentle-baby-wipes-with-organic-coconut-oil-neem-with-lid-80-wipes-x-3-packs-791',
        deepLinkType: 'next',
      },
    ],
  },
  {
    type: 2,
    title: 'Shop Mylo Care',
    deepLink: '/',
    deepLinkType: 'next',
    subCategories: [
      {
        name: 'Pregnancy & New Mom',
        deepLink: '/category/pregnancy-new-mom-products-7569',
        deepLinkType: 'next',
      },
      {
        name: 'Skin',
        deepLink: '/category/skin-care-products-7510',
        deepLinkType: 'next',
      },
      {
        name: 'Daily Wellness',
        deepLink: '/category/everyday-health-products-7515',
        deepLinkType: 'next',
      },
      {
        name: 'Bath & Body',
        deepLink: '/category/bath-body-products-7567',
        deepLinkType: 'next',
      },
      {
        name: 'Fertility',
        deepLink: '/category/fertility-boosting-products-7517',
        deepLinkType: 'next',
      },
      {
        name: 'Hair',
        deepLink: '/category/hair-care-products-7511',
        deepLinkType: 'next',
      },
      {
        name: 'Hygiene',
        deepLink: '/category/hygiene-products-7568',
        deepLinkType: 'next',
      },
      {
        name: 'Weight',
        deepLink: '/category/weight-loss-products-7516',
        deepLinkType: 'next',
      },
    ],
  },
  {
    type: 2,
    title: 'Shop Mylo Baby',
    deepLink: '/parenting',
    deepLinkType: 'next',
    subCategories: [
      {
        name: 'Diapers & Wipes',
        deepLink: '/category/diapers-wipes-7504',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Wellness',
        deepLink: '/category/baby-wellness-products-7566',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Care',
        deepLink: '/category/baby-care-7505',
        deepLinkType: 'next',
      },
      {
        name: 'Feeding & Lactation',
        deepLink: '/category/feeding-lactation-7506',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Clothing',
        deepLink: '/category/baby-clothes-7508',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Gear',
        deepLink: '/category/baby-activity-gear-7507',
        deepLinkType: 'next',
      },
    ],
  },
  {
    type: 1,
    title: 'Pregnancy Planning',
    deepLink: '/parenting/pregnancy-planning',
    deepLinkType: 'next',
  },
  {
    type: 1,
    title: 'Pregnancy',
    deepLink: '/parenting/pregnancy',
    deepLinkType: 'next',
  },
  {
    type: 1,
    title: 'Infant',
    deepLink: '/parenting/infant',
    deepLinkType: 'next',
  },
  {
    type: 1,
    title: 'Toddler (1-3 Years)',
    deepLink: '/parenting/toddler',
    deepLinkType: 'next',
  },
  {
    type: 1,
    title: 'Topics',
    deepLink: '/topics',
    deepLinkType: 'next',
  },
  {
    type: 0, // 0 for both, 1 for header only, 2 for footer only
    title: 'Mylo Community',
    deepLink: '/tools',
    deepLinkType: 'other',
    subCategories: [
      {
        name: 'Parenting',
        deepLink: '/parenting',
        deepLinkType: 'next',
      },
      {
        name: 'Pregnancy Planning',
        deepLink: '/parenting/pregnancy-planning',
        deepLinkType: 'next',
      },
      {
        name: 'Pregnancy',
        deepLink: '/parenting/pregnancy',
        deepLinkType: 'next',
      },
      {
        name: 'Infant',
        deepLink: '/parenting/infant',
        deepLinkType: 'next',
      },
      {
        name: 'Toddler (1-3 Years)',
        deepLink: '/parenting/toddler',
        deepLinkType: 'next',
      },
      {
        name: 'Topics',
        deepLink: '/topics',
        deepLinkType: 'next',
      },
      {
        name: 'Download Mylo Baby App',
        deepLink:
          'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web',
        deepLinkType: 'other',
        proj: 'angular',
      },
      {
        name: 'Pregnancy Week by Week',
        deepLink: '/parenting/pregnancy',
        deepLinkType: 'other',
      },
      {
        name: 'Baby Names',
        deepLink: '/parenting/babynames',
        deepLinkType: 'next',
      },
      {
        name: 'Coloring Pages For Kids',
        deepLink: '/coloring-pages-for-kids',
        deepLinkType: 'next',
      },
    ],
  },

  {
    type: 2,
    title: 'Trending Categories',
    subCategories: [
      {
        name: 'Baby Diapers',
        deepLink: '/product/mylo-baby-diaper-pants-small-size',
        deepLinkType: 'next',
      },
      {
        name: 'Baby Skin Care',
        deepLink: '/category/baby-skin-care-products-7519',
        deepLinkType: 'next',
      },

      {
        name: 'Baby Bath Essentials',
        deepLink: '/category/baby-care-7505',
        deepLinkType: 'next',
      },
      {
        name: 'Maternity Essentials',
        deepLink: '/category/maternity-wear-products-5366',
        deepLinkType: 'next',
      },
    ],
  },
  // {
  //     type: 2, // 0 for both, 1 for header only, 2 for footer only
  //     title: "Useful Links",
  //     subCategories: [
  //         // {
  //         //     name: "About Us",
  //         //     deepLink: "/about-mylo",
  //         //     deepLinkType: "next",
  //         // },
  //         {
  //             name: "Privacy Policy",
  //             deepLink: "/privacy-policy",
  //             deepLinkType: "other",
  //         },
  //         {
  //             name: "Returns & Cancellation",
  //             deepLink: "/refund-cancellation",
  //             deepLinkType: "next",
  //         },
  //         // {
  //         //     name: "Cancellation",
  //         //     deepLink: "/refund-cancellation",
  //         //     deepLinkType: "next",
  //         // },
  //         {
  //             name: "Contact Us",
  //             deepLink: "/contact-us",
  //             deepLinkType: "next",
  //         },
  //         {
  //             name: "Sitemap ",
  //             deepLink: "/sitemap",
  //             deepLinkType: "next",
  //         },
  //         {
  //             name: "Product Category Glossary",
  //             deepLink: "/product-category-sitemap",
  //             deepLinkType: "next",
  //         },
  //     ],
  // },

  {
    type: 1, // 0 for both, 1 for header only, 2 for footer only
    title: 'Get Mylo App',
    deepLink: googlePlayStoreLink.split('?')?.[0],
    deepLinkType: 'other',
    externalRedirect: true,
  },
  // {
  //     type: 1, // 0 for both, 1 for header only, 2 for footer only
  //     title: "हिन्दी",
  //     deepLink: "/hi/parenting",
  //     deepLinkType: "other",
  // },
  // {
  //     type: 1, // 0 for both, 1 for header only, 2 for footer only
  //     title: "বাঙ্গালী",
  //     deepLink: "/bn/parenting",
  //     deepLinkType: "other",
  // },
];

export const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export const monthsinYear = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const monthsShortForm = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'June',
  'July',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

export const monthsInHindi = [
  'जनवरी',
  'फ़रवरी',
  'मार्च',
  'अप्रैल',
  'मई',
  'जून',
  'जुलाई',
  'अगस्त',
  'सितम्बर',
  'अक्टूबर',
  'नवम्बर',
  'दिसम्बर',
];

// hardcoded data for stages cards
export const stagesData = [
  {
    title: 'TRYING TO CONCEIVE',
    imgUrl: images.ttc,
    id: 103121,
    clickUrl: 'https://mylofamily.com/topic/ttc',
    listItems: [
      { id: 101, data: 'Daily tip + videos via expert & doctors' },
      { id: 102, data: 'Period & ovulation tracker' },
      { id: 103, data: '15 essential tool for healthy life' },
      {
        id: 104,
        data: 'Active community of 10+ Lac Moms to help you conceive',
      },
      { id: 105, data: 'Read daily articles on 500+ topics' },
    ],
  },
  {
    title: 'PREGNANT',
    imgUrl: images.pregnancy,
    id: 103122,
    clickUrl: 'https://mylofamily.com/topic/pregnant',
    listItems: [
      { id: 106, data: 'Daily tip + videos via expert & doctors' },
      {
        id: 107,
        data: 'Week by week pregnancy tracker (Know your body changes)',
      },
      {
        id: 108,
        data: '25+ tools to guide you through pregnancy journey',
      },
      {
        id: 109,
        data: 'Active community of 10+ Lac Moms to help you deliver',
      },
      { id: 110, data: 'Daily customised articles on 500+ topics' },
    ],
  },
  {
    title: 'MOTHER',
    imgUrl: images.parent,
    id: 103123,
    clickUrl: 'https://mylofamily.com/topic/infant',
    listItems: [
      { id: 111, data: 'Daily tip + videos via expert & doctors' },
      {
        id: 112,
        data: 'Baby diet chart of all ages (Know everything about feeding your little one)',
      },
      { id: 113, data: '20+ tools to help you raise your baby' },
      {
        id: 114,
        data: 'Active community of 10+ Lac Moms to guide you through your journey',
      },
      { id: 115, data: 'Daily new articles on 500+ topics' },
    ],
  },
];

export const relatedArticlesContent = [
  {
    contentCount: 5214,
    description: 'Caring for your Newborn',
    following: 8539,
    icon: images.newborn,
    image: images.newborn,
    isFollow: false,
    is_contest: false,
    is_functional: 0,
    meta_description:
      'Newborn care and safety are the activities and precautions recommended for new parents or caregivers ',
    name: 'NewbornCare',
    parent_id: 4178,
    tag_image: null,
    tag_image_hindi: null,
    taxonomyId: 4182,
    term_id: 4182,
    webUrl: '/topic/newborn-care-4182',
  },
  {
    contentCount: 1272348,
    icon: images.early_pregnancy,
    is_functional: 0,
    term_id: 1919,
    name: 'pregnant',
    description: 'Early Pregnancy',
    meta_description:
      'This is a safe space to ask questions and share insights on everything from prenatal care and morning sickness to labor and delivery.',
    tag_image: null,
    tag_image_hindi: null,
    color: null,
    category_banner: null,
    category_banner_hindi: null,
    parent_id: 1925,
    image: images.early_pregnancy,
    is_contest: false,
    following: 1306024,
    isFollow: true,
    webUrl: '/topic/early-pregnancy-4527',
  },
  {
    contentCount: 13057,
    description: 'New Mom',
    filter_selector: null,
    following: 8663,
    icon: images.newMom,
    image: images.newMom,
    isFollow: false,
    is_contest: false,
    is_functional: 0,
    meta_description:
      'A woman who has just delivered a baby is also called a new mom',
    name: 'NewMom',
    parent_id: 4333,
    tag_image: null,
    tag_image_hindi: null,
    taxonomyId: 4142,
    term_id: 4142,
    web_url: '/topic/new-mom-4142',
  },
  {
    contentCount: 117953,
    icon: images.diet_nutrition,
    is_functional: 0,
    term_id: 4145,
    name: 'Diet&Nutrition',
    description: 'Diet & Nutrition',
    meta_description:
      "Healthy eating during pregnancy is critical to your baby's growth and development. In order to get the nutrients you need, you must eat from a variety of food groups, including fruits and vegetables, breads and grains, protein sources and dairy products",
    tag_image: null,
    tag_image_hindi: null,
    color: null,
    category_banner: null,
    category_banner_hindi: null,
    parent_id: 4122,
    image: images.diet_nutrition,
    is_contest: false,
    following: 50690,
    isFollow: true,
    webUrl: '/topic/diet-nutrition-4145',
  },
  {
    contentCount: 247753,
    icon: images.pregnancy_journey,
    is_functional: 0,
    term_id: 4124,
    name: 'PregnancyJourney',
    description: 'Pregnancy Journey',
    meta_description:
      'Pregnancy journey, also known as gestation, is the time during which one or more offspring develops inside a woman',
    tag_image: null,
    tag_image_hindi: null,
    color: null,
    category_banner: null,
    category_banner_hindi: null,
    parent_id: 1919,
    image: images.pregnancy_journey,
    is_contest: false,
    following: 62328,
    isFollow: true,
    webUrl: '/topic/pregnancy-journey-4124',
  },
  {
    contentCount: 16897,
    icon: images.food_recipes,
    is_functional: 0,
    term_id: 4216,
    name: 'Recipes',
    description: 'Food & Recipes',
    meta_description:
      'A set of instructions for preparing a particular dish, including a list of the ingredients required',
    tag_image: null,
    tag_image_hindi: null,
    color: null,
    category_banner: null,
    category_banner_hindi: null,
    parent_id: 4145,
    image: images.food_recipes,
    is_contest: false,
    following: 31045,
    isFollow: true,
    webUrl: '/topic/food-recipes-4216',
  },
];

export const stretchMarksFAQ = [
  {
    question: 'Can anyone use Mylo Stretch Marks Cream?',
    answer:
      'Yes. All pregnant women, young moms, moms with existing stretch marks and any women facing issues of stretch marks or itching can use it.',
  },
  {
    question: 'Is it safe to use Mylo Stretch Marks Cream in pregnancy? ?',
    answer:
      'Yes, Mylo Stretch Marks Cream is totally safe to use during pregnancy, breastfeeding and postpartum. ',
  },
  {
    question: 'Can I use this cream to remove my itching on belly/stomach?',
    answer:
      'Yes, Mylo Stretch Marks Cream contains Shea Butter which helps in reducing itching and healing itchy skin. ',
  },
  {
    question: 'Can this cream cause allergy? ',
    answer:
      'Mylo Care Stretch Marks Cream is made using natural ingredients and allergy-free. It is also free from any parabens, sulphates & harmful chemicals',
  },
  {
    question:
      'Can this work on my old stretch marks? / I have 1 year old stretch marks can it remove? ',
    answer:
      'Removing old stretch marks can be difficult but feedback from many users show that a regular usage may help reduce stretch marks.',
  },
];

export const newHeaderData = [
  {
    tabName: 'store',
    key: '/',
    image: images.Store,
    type: '1',
    height: '18',
    width: '15',
  },
  {
    tabName: 'Wellness',
    key: '/clinic',
    image: images.Clinic,
    type: '2',
    height: '19',
    width: '18.5',
  },
  {
    tabName: 'parenting',
    key: '/parenting',
    image: images.Parenting,
    type: '3',
    height: '19',
    width: '31',
    subCategories: [
      {
        tabName: 'Home',
        key: '/parenting',
        deepLinkType: 'next',
      },
      {
        tabName: 'Pregnancy Planning',
        key: '/parenting/pregnancy-planning',
        deepLinkType: 'next',
      },
      {
        tabName: 'Pregnancy',
        key: '/parenting/pregnancy',
        deepLinkType: 'next',
      },
      {
        tabName: 'Infant',
        key: '/parenting/infant',
        deepLinkType: 'next',
      },
      {
        tabName: 'Toddler',
        key: '/parenting/toddler',
        deepLinkType: 'next',
      },
      {
        tabName: 'Topics',
        key: '/topics',
        deepLinkType: 'next',
      },
      {
        tabName: 'Other Languages',
        key: '/',
        deepLinkType: 'next',
        subCategories: [
          {
            image: '',
            tabName: 'हिन्दी',
            key: '/hi/parenting',
          },
          {
            image: '',
            tabName: 'বাঙ্গালী',
            key: '/bn/parenting',
          },
          {
            image: '',
            tabName: 'தமிழ்',
            key: '/ta/parenting',
          },
          {
            image: '',
            tabName: 'తెలుగు',
            key: '/te/parenting',
          },
        ],
      },
    ],
  },
];

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
